export default [{
  name: 'supplement/info',
  path: '/supplement/info',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/supplement/info.vue')
}, {
  name: 'supplement/identity',
  path: '/supplement/identity',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/supplement/identity.vue')
}, {
  name: 'supplement/identity/face',
  path: '/supplement/identity/face',
  meta: {
    needLogin: true
  },
  component: () => import('@/view/supplement/identity-face.vue')
}, {
  name: 'supplement/eg',
  path: '/supplement/eg',
  component: () => import('@/view/supplement/eg.vue')
}, {
  name: 'supplement/result',
  path: '/supplement/result',
  component: () => import('@/view/supplement/identity-result.vue')
},
{
  name: 'supplement/vendor',
  path: '/supplement/vendor',
  component: () => import('@/view/supplement/vendor.vue')
},
]
